import React, { useState } from 'react';
import { FileDrop } from 'react-file-drop';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import DragDropSvg from '../../../assets/icons/DragDropSvg';

const FileDropComponent = ({
  onClick,
  onFilesDropped,
  customTitle,
  customSupportedFileTypes,
}: {
  onFilesDropped?: (
    files: FileList | null,
    event: React.DragEvent<HTMLDivElement>,
  ) => void;
  onClick: () => void;
  customTitle?: string;
  customSupportedFileTypes?: string;
}) => {
  const { t } = useTranslation('Host');

  const [isDraggingOver, setIsDraggingOver] = useState(false);
  return (
    <Container>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
      {/* @ts-ignore */}
      <FileDrop
        onTargetClick={onClick}
        onDrop={(files, event) => onFilesDropped && onFilesDropped(files, event)}
        onDragOver={() => setIsDraggingOver(true)}
        onDragLeave={() => setIsDraggingOver(false)}
      >
        <ContentContainer $isDraggingOver={isDraggingOver}>
          <DragDropSvg />
          <Title>
            {customTitle ? customTitle : t('Drag and drop or click to select an image')}
          </Title>
          <Description>
            {customSupportedFileTypes
              ? customSupportedFileTypes
              : t(
                  'AllSupportedFileTypes',
                  'Supported file types are .jpg, .png, .webp, .heic and .gif',
                )}
          </Description>
        </ContentContainer>
      </FileDrop>
    </Container>
  );
};

export default FileDropComponent;

const Title = styled.p`
  &&& {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0px;
    margin-top: 0px;
    text-align: center;
    user-select: none;
    color: rgba(58, 175, 255, 1);
  }
`;

const Description = styled.p`
  &&& {
    font-size: 10px;
    font-weight: normal;
    margin-top: 0px;
    margin-bottom: 0px;
    text-align: center;
    user-select: none;
    color: rgba(58, 175, 255, 1);
  }
`;

const ContentContainer = styled.div<{ $isDraggingOver?: boolean }>`
  height: 100%;
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  border: 1px dashed rgba(58, 175, 255, 1);
  background-color: rgba(58, 175, 255, 0.2);
  color: rgba(58, 175, 255, 1);
  cursor: pointer;

  &:hover {
    background-color: rgba(58, 175, 255, 0.1);
  }

  &:active {
    background-color: rgba(58, 175, 255, 0.2);
  }

  ${({ $isDraggingOver }) =>
    $isDraggingOver &&
    css`
      background-color: rgba(58, 175, 255, 0.1) !important;
    `};
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;

  .file-drop {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .file-drop-target {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .file-drop > .file-drop-target.file-drop-dragging-over-frame > div {
    background-color: rgba(58, 175, 255, 0.2);
  }
`;
